export const tracking = {
    apiUrl: process.env.REACT_APP_APP_BACKEND_URL,
    clientId: process.env.CLIENT_ID,
    clientSecret: process.env.CLIENT_SECRET,
}
// export const sentryConfig = {
// 	DSN: process.env.EXPO_PUBLIC_SENTRY_DSN,
// 	ENV: process.env.EXPO_PUBLIC_SENTRY_ENV
// }
